import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Metadata from '../components/Metadata';
import PageHero from '../components/PageHero';
import SectionHeading from '../components/SectionHeading';
import ServiceCard from '../components/ServiceCard';
import { assets, pageMeta, serviceCards } from '../data/siteData';
import { assetUrl } from '../lib/media';

export default function ServicesPage() {
  return (
    <>
      <Metadata
        title={pageMeta.services.title}
        description={pageMeta.services.description}
        image={assetUrl(pageMeta.services.ogImage, 1200)}
        path="/ydelser"
      />

      <PageHero
        eyebrow="Ydelser"
        title="Håndværk til både nye projekter og forbedringer af eksisterende boliger"
        description="RS Byg leverer tømrerarbejde og renoveringsløsninger med samme fokus på kvalitet, orden og tydelig kommunikation, uanset om opgaven er stor eller lille."
        image={assets.hero}
        primaryAction={{ label: 'Kontakt os', to: '/kontakt' }}
        secondaryAction={{ label: 'Se galleri', to: '/galleri' }}
      />

      <section className="bg-brand-gray-50 py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHeading
            eyebrow="Oversigt"
            title="Vælg den løsning, der passer til dit projekt"
            description="Alle services er organiseret som separate undersider, så du hurtigt kan finde den rigtige information og relevante billeder."
          />

          <div className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
            {serviceCards.map((service) => (
              <ServiceCard key={service.slug} service={service} />
            ))}
          </div>

          <div className="mt-10 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
            <article className="border border-brand-gray-200 bg-white p-6">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-orange">Proces</p>
              <h2 className="mt-4 font-display text-3xl font-bold text-brand-black">
                Vi gør processen enkel og overskuelig
              </h2>
              <p className="mt-4 text-sm leading-7 text-brand-gray-600">
                Du får en klar dialog fra første kontakt. Vi gennemgår opgaven, materialer og tidsplan, så du ved, hvad der sker og hvornår.
              </p>
            </article>

            <article className="border border-brand-gray-200 bg-brand-black p-6 text-white">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-orange">Klar til at starte?</p>
              <h2 className="mt-4 font-display text-3xl font-bold text-white">
                Lad os tage en snak om dit næste projekt
              </h2>
              <p className="mt-4 text-sm leading-7 text-brand-gray-200">
                Vi hjælper gerne med rådgivning, materialevalg og et uforpligtende tilbud.
              </p>
              <Link to="/kontakt" className="mt-6 inline-flex items-center justify-center bg-brand-orange px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-brand-orange-hover">
                Kontakt RS Byg
                <ArrowRight className="ml-3 h-4 w-4" />
              </Link>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}
